import { Tooltip } from 'antd'
import React from 'react'

export const TooltipIcon = ({ title, Icon, href, target = null, color, onClick, label=null, style={}, rel = '', className = '' }: any) => {
  return (
    <Tooltip title={title}>
      <a onClick={onClick} href={href} target={target} rel={rel}>
        <Icon style={{ color, ...style }} className={className} />
        {" "}
        {label && (<span className={"link-item"}>{label}</span>)}
      </a>
    </Tooltip>
  )
}
